define(["require", "exports", "@lit/context"], function (require, exports, context_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.customElementRegistry = void 0;
    class CustomElementRegistryProxy {
        constructor() {
            this.customElements = {};
            this.contextRoot = new context_1.ContextRoot();
        }
        register(name, constructor, options) {
            if (name in this.customElements) {
                throw new Error(`CustomElement ${name} already registered!`);
            }
            this.customElements[name] = [constructor, options, false];
        }
        defineAll(customElements, rootEl) {
            if (rootEl) {
                this.contextRoot.attach(rootEl);
            }
            // here we also create a ContextRoot to capture and reregister future providers.
            for (const key of Object.keys(this.customElements)) {
                let [constructor, options, defined] = this.customElements[key];
                if (!defined) {
                    customElements.define(key, constructor, options);
                }
                this.customElements[key][2] = true;
            }
        }
    }
    exports.customElementRegistry = new CustomElementRegistryProxy();
});
